<template>
	<v-container>
		<AdminTextos />
		<AdminCursos />
	</v-container>
</template>

<script>
	import AdminTextos from '@/components/admin/textos/AdminTextos'
	import AdminCursos from '@/components/admin/cursos/AdminCursos'

	export default{
		name: 'AdminPages',
		components: { 
			AdminTextos,
			AdminCursos
			},
		computed:{
			

		},
		data(){
			return{

			}
		},

		methods:{
			
		},

		created(){
			
		}
	}

</script>

<style scoped>

</style>